import * as React from "react";
import * as ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {ConnectedRouter} from "connected-react-router";

import App from "./app/App";
import history from "./~store/history";
import configureStore from "./~store/configureStore";
import registerServiceWorker from "./registerServiceWorker";

const store = configureStore(history);

const removeLoadingSpinner = function () {    
    const element = document.getElementById("loading-cover");
    if (element) element.style.display = "none";
    const rootElement = document.getElementById("root");
    if (rootElement) rootElement.style.display = "block";
}

window.onload = removeLoadingSpinner;

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById("root") as HTMLElement

);

registerServiceWorker();

const urlParams = new URLSearchParams(window.location.search);
const css = urlParams.get('css');
document.title = urlParams.get('pageName') ?? 'Chat Widget';
if (css?.length === 0 || css === null) { console.log('Standarted styles'); } else {
    const style = document.createElement('link');
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('href', css);
    document.head.appendChild(style);
}
           